/* PreviewScreenWithLogic.tsx generated by @compiled/babel-plugin v0.36.1 */
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ax, ix } from "@compiled/react/runtime";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { aiExperienceApplicationMessages } from '@atlaskit/editor-common/ai-messages';
import { ACTION, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { fg } from '@atlaskit/platform-feature-flags';
import { Text } from '@atlaskit/primitives/compiled';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { useThemeObserver } from '@atlaskit/tokens';
import { ProseMirrorContentStatistics } from '@atlassian/ai-model-io/utils/prosemirror-content-statistics';
import { stripMatchingOuterQuotes } from '@atlassian/ai-model-io/utils/strip-matching-outer-quotes';
import { createUnifiedAnalyticsPayload } from '@atlassian/editor-ai-common/analytics/create-unified-analytics-payload';
import { copyPMFragmentToClipboard } from '@atlassian/editor-ai-common/utils/clipboard';
import { ErrorUtils } from '@atlassian/editor-ai-common/utils/errors';
import { PreviewScreen } from '@atlassian/generative-ai-modal/screens/Preview';
import { useAIExperienceCommonDataContext } from '../../../hooks/useAIExperienceCommonData';
import { useAIUsageDisclaimer } from '../../../hooks/useAIUsageDisclaimer';
import { useCreateGenericChatActionPayload } from '../../../hooks/useCreateGenericChatActionPayload';
import { useLocalizedLatestPrompt } from '../../../hooks/useLocalizedLatestPrompt';
import { useOutsideClickHandler } from '../../../hooks/useOutsideClickHandler';
import { usePromptStatistics } from '../../../hooks/usePromptStatistics';
import { getAllEditorPluginAIConfigItems, getEditorPluginAIConfigItemActions } from '../../../prebuilt/config-items/config-items';
import { isConfluenceTitleToolbarSuggestTitle } from '../../../prebuilt/config-items/utils/is-title-toolbar-suggest-title';
import { convertExperienceName } from '../../../utils/analytics/analyticsFlow';
import { useAnalyticsFlow } from '../../../utils/analytics/analyticsFlowUtils';
import { useFireAIAnalyticsEvent } from '../../../utils/analytics/utils';
import { convertPMFragmentToPreview } from '../../../utils/convert-markdown-to-preview';
import { createDiffPreview } from '../../../utils/create-diff-preview';
import { shouldDiscardEndExperienceImmediately } from '../../../utils/discard-handling';
import { FAILURE_REASON } from '../../../utils/errors';
import { getPMFragmentWithFallback } from '../../../utils/get-pm-fragment-with-fallback';
import { PreviewEditorWrapper } from '../../PreviewEditorWrapper/PreviewEditorWrapper';
export function PreviewScreenWithLogic(_ref) {
  var _configItem$agent2, _configItem$disableIn, _history$entries$, _configItem$secondary;
  var aiExperienceMachineContext = _ref.aiExperienceMachineContext,
    isInputActive = _ref.isInputActive,
    backendModel = _ref.backendModel,
    rovoAction = _ref.rovoAction,
    rovoPublish = _ref.rovoPublish;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var isEmpty = aiExperienceMachineContext.isEmpty,
    parentPresetPromptLabel = aiExperienceMachineContext.parentPresetPromptLabel,
    latestPrompt = aiExperienceMachineContext.latestPrompt,
    actualMarkdown = aiExperienceMachineContext.markdown,
    configItem = aiExperienceMachineContext.configItem,
    actualUserInput = aiExperienceMachineContext.userInput,
    actualUserADFInput = aiExperienceMachineContext.userADFInput,
    editCount = aiExperienceMachineContext.editCount,
    retryPromptCount = aiExperienceMachineContext.retryPromptCount,
    refinementCount = aiExperienceMachineContext.refinementCount,
    idMap = aiExperienceMachineContext.idMap,
    history = aiExperienceMachineContext.responseHistory,
    contextStatistics = aiExperienceMachineContext.contextStatistics,
    promptTrigger = aiExperienceMachineContext.promptTrigger,
    channelId = aiExperienceMachineContext.channelId;
  var aiExperienceCommonData = useAIExperienceCommonDataContext();
  var appearance = aiExperienceCommonData.appearance,
    editorPluginAIProvider = aiExperienceCommonData.editorPluginAIProvider,
    editorView = aiExperienceCommonData.editorView,
    endExperience = aiExperienceCommonData.endExperience,
    positions = aiExperienceCommonData.positions,
    providerFactory = aiExperienceCommonData.providerFactory,
    sendToAIExperienceMachine = aiExperienceCommonData.sendToAIExperienceMachine,
    lastTriggeredFrom = aiExperienceCommonData.lastTriggeredFrom,
    modalRef = aiExperienceCommonData.modalRef,
    triggeredFor = aiExperienceCommonData.triggeredFor,
    includeKnowledgeFromCurrentPage = aiExperienceCommonData.includeKnowledgeFromCurrentPage;
  var disclaimer = useAIUsageDisclaimer({
    editorPluginAIProvider: editorPluginAIProvider
  });

  /**
   * Short title for the submenu if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
   * If the user selects a submenu directly, this will be empty (search and select `Change tone to Neutral`)
   */
  var childShortTitle = parentPresetPromptLabel && configItem.nestingConfig ? formatMessage(configItem.nestingConfig.shortTitle) : '';
  var userInput = actualUserInput || '';
  var userADFInput = actualUserADFInput;
  var schema = editorView.state.schema;
  var product = editorPluginAIProvider.product;
  /**
   * Please check with Ethan/PM upon removing onExperienceEvent
   * calls, to confirm it is no longer used in any ongoing experiments.
   */
  useEffect(function () {
    var _editorPluginAIProvid;
    (_editorPluginAIProvid = editorPluginAIProvider.onExperienceEvent) === null || _editorPluginAIProvid === void 0 || _editorPluginAIProvid.REVIEW_STATE_ENTERED();
  }, [editorPluginAIProvider]);
  var clearInputRef = useRef();
  var lastHistoryEvent = history.entries[history.positionFromEnd];
  var responseTooSimilar = lastHistoryEvent.responseTooSimilar;
  var inputOutputDiffRatio = lastHistoryEvent.inputOutputDiffRatio;
  var markdown = actualMarkdown || '';
  var _fireAIAnalyticsEvent = useFireAIAnalyticsEvent();
  var analyticsFlow = useAnalyticsFlow();
  var enqueuedPreviewStep = useRef(false);
  var errorReported = React.useRef(false);
  if (markdown && isConfluenceTitleToolbarSuggestTitle({
    configItem: configItem,
    lastTriggeredFrom: lastTriggeredFrom
  })) {
    markdown = stripMatchingOuterQuotes(markdown);
  }
  var pmFragmentPreviewData = getPMFragmentWithFallback({
    markdown: markdown,
    schema: schema,
    source: 'preview',
    fireAIAnalyticsEvent: function fireAIAnalyticsEvent(event) {
      if (!errorReported.current) {
        errorReported.current = true;
        _fireAIAnalyticsEvent(event);
      }
    },
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    idMap: idMap
  });
  var pmFragment = (pmFragmentPreviewData === null || pmFragmentPreviewData === void 0 ? void 0 : pmFragmentPreviewData.pmFragment) || Fragment.empty;
  var _useState = useState(pmFragment),
    _useState2 = _slicedToArray(_useState, 2),
    updatedFragment = _useState2[0],
    setUpdatedFragment = _useState2[1];
  var onFragmentChange = React.useCallback(function (fragment) {
    setUpdatedFragment(fragment);
  }, [setUpdatedFragment]);
  var preview = getPreviewElement(pmFragment);
  useOutsideClickHandler({
    modalRef: modalRef,
    userInput: userInput,
    onCancel: function onCancel() {
      return sendToAIExperienceMachine({
        type: 'enable discard'
      });
    },
    onDiscard: function onDiscard() {
      return sendToAIExperienceMachine({
        type: 'enable discard'
      });
    }
  });

  /**
   * gets preview JSX element based on fragment
   */
  function getPreviewElement(pmFragment) {
    if (responseTooSimilar) {
      var responseTooSimilarMessage = formatMessage(aiExperienceApplicationMessages.responseTooSimilarMessage);
      return /*#__PURE__*/React.createElement(Text, {
        as: "p"
      }, responseTooSimilarMessage);
    }
    if (editorExperiment('platform_editor_ai_edit_response_in_preview', true, {
      exposure: true
    })) {
      return /*#__PURE__*/React.createElement(PreviewEditorWrapper, {
        schema: schema,
        pmFragment: pmFragment,
        PromptEditor: editorPluginAIProvider.PromptEditor,
        onFragmentChange: onFragmentChange
      });
    } else {
      return convertPMFragmentToPreview({
        schema: schema,
        pmFragment: pmFragment,
        showTelepointer: false,
        providerFactory: providerFactory
      });
    }
  }

  // preset prompt or base generate / interrogation
  var localizedLatestPrompt = useLocalizedLatestPrompt(latestPrompt);
  var promptStatistics = usePromptStatistics(localizedLatestPrompt);
  useEffect(function () {
    analyticsFlow.fireQueuedStep('preview');
    var modelIO;
    if (pmFragmentPreviewData) {
      var _lastHistoryEvent$mod;
      var stats = new ProseMirrorContentStatistics(pmFragment);
      var contentStatistics = stats.collectStatistics();
      modelIO = {
        selectionSize: (_lastHistoryEvent$mod = lastHistoryEvent.modelInput.selection) === null || _lastHistoryEvent$mod === void 0 ? void 0 : _lastHistoryEvent$mod.length,
        nodesConvertedToHTMLInput: idMap ? Object.keys(idMap).length : undefined,
        outputUnclosedTokens: pmFragmentPreviewData.unclosedTokens,
        outputHTMLConvertedToNodes: pmFragmentPreviewData.htmlConvertedToNodes,
        outputHTMLConvertedToFallbackNodes: pmFragmentPreviewData.htmlConvertedToFallbackNodes,
        isTextFallbackUsed: pmFragmentPreviewData.isTextFallbackUsed,
        previewNodeCounts: contentStatistics.nodeCounts,
        previewMarkCounts: contentStatistics.markCounts,
        previewTotalCharacterCounts: contentStatistics.totalCharacterCount,
        userInputCharacterCount: promptStatistics === null || promptStatistics === void 0 ? void 0 : promptStatistics.totalCharacterCount,
        userInputNodeCounts: promptStatistics === null || promptStatistics === void 0 ? void 0 : promptStatistics.nodeCounts,
        userInputLinksCount: promptStatistics === null || promptStatistics === void 0 ? void 0 : promptStatistics.linksCount,
        userInputMentionsCount: promptStatistics === null || promptStatistics === void 0 ? void 0 : promptStatistics.mentionsCount
      };
    }
    analyticsFlow.addAttributes({
      editCount: editCount,
      responseTooSimilar: responseTooSimilar,
      modelIO: _objectSpread({
        contextStatistics: contextStatistics
      }, modelIO),
      inputOutputDiffRatio: inputOutputDiffRatio
    });
    return function () {
      // We only want to enqueue the preview step if it hasn't been enqueued
      // already. This is to handle the case where the user clicks on an
      // ai action button where we manually enqueue the analytics event,
      // and then seperately fire a complete step.

      if (enqueuedPreviewStep.current === false) {
        analyticsFlow.enqueueStep({
          stepName: 'preview',
          attributes: undefined
        });
      }
    };
    // expecting to enqueue step only once on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _useThemeObserver = useThemeObserver(),
    _useThemeObserver$col = _useThemeObserver.colorMode,
    colorMode = _useThemeObserver$col === void 0 ? 'light' : _useThemeObserver$col;
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    diffPreview = _useState4[0],
    setDiffPreview = _useState4[1];
  var isVisualDiffPreviewEnabled = configItem.canToggleDiffPreview && 'backgroundColor' in schema.marks && fg('platform_editor_ai_visual_diff_preview');
  useEffect(function () {
    if (isVisualDiffPreviewEnabled && !responseTooSimilar && pmFragment) {
      var diff = createDiffPreview({
        editorView: editorView,
        pmFragment: pmFragment,
        positions: positions,
        providerFactory: providerFactory,
        colorMode: colorMode
      });
      if (diff) {
        setDiffPreview(diff);
      }
    }
  },
  // We only need to calculate the diff once
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isVisualDiffPreviewEnabled]);
  var fireDismissEvent = useCallback(function () {
    // Introduced in EDF-1443 to track Retry events as AI response dismissal
    _fireAIAnalyticsEvent({
      payload: createUnifiedAnalyticsPayload({
        action: ACTION.DISMISSED,
        attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
          init: false
        }),
        experienceName: convertExperienceName(configItem.key.toString(), lastTriggeredFrom),
        interactionID: channelId !== null && channelId !== void 0 ? channelId : analyticsFlow.getLastAiInteractionId(),
        invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
        isProactive: false
      })
    });
  }, [analyticsFlow, aiExperienceCommonData.lastTriggeredFrom, channelId, configItem.key, _fireAIAnalyticsEvent, lastTriggeredFrom]);
  var fireResponseFeedbackEvent = function fireResponseFeedbackEvent(sentiment, productSuccessState) {
    var _configItem$agent;
    _fireAIAnalyticsEvent({
      payload: {
        action: 'click',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'responseFeedbackButton',
        attributes: {
          sentiment: sentiment,
          appearance: appearance,
          product: product,
          configItemTitle: ((_configItem$agent = configItem.agent) === null || _configItem$agent === void 0 ? void 0 : _configItem$agent.name) || configItem.key,
          lastTriggeredFrom: lastTriggeredFrom,
          productSuccessStatus: productSuccessState,
          inputOutputDiffRatio: inputOutputDiffRatio,
          retryPromptCount: retryPromptCount,
          responseTooSimilar: responseTooSimilar,
          aiInteractionID: analyticsFlow.getLastAiInteractionId()
        },
        eventType: EVENT_TYPE.UI
      }
    });
    _fireAIAnalyticsEvent({
      payload: createUnifiedAnalyticsPayload({
        action: ACTION.SUBMITTED,
        interactionID: channelId !== null && channelId !== void 0 ? channelId : analyticsFlow.getLastAiInteractionId(),
        experienceName: convertExperienceName(configItem.key.toString(), lastTriggeredFrom),
        isProactive: false,
        invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
        attributes: _objectSpread({
          aiFeedbackResult: sentiment === 'good' ? 'up' : 'down'
        }, analyticsFlow.getAiLifeCycleDynamicAttributes({
          init: false
        }))
      })
    });
  };
  var handleFiringFeedbackEvent = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(feedbackMetadata) {
      var productResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            analyticsFlow.addAttributes({
              userFeedbackSentiment: feedbackMetadata.sentiment
            });

            // we need to update the state machine to reflect the user feedback
            sendToAIExperienceMachine({
              type: 'feedback submitted',
              sentiment: feedbackMetadata.sentiment
            });

            // handleFeedbackSubmission is intended to be implemented
            // by all products -- there will be a period where products won't have
            // it implemented (and will be relying on THUMBS_UP/THUMBS_DOWN)
            // in these cases -- we don't know the product response status
            if (editorPluginAIProvider.handleFeedbackSubmission) {
              _context.next = 7;
              break;
            }
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
            return _context.abrupt("return");
          case 7:
            _context.prev = 7;
            _context.next = 10;
            return editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
          case 10:
            productResponse = _context.sent;
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](7);
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 14]]);
    }));
    return function handleFiringFeedbackEvent(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onEditPromptClick = useCallback(function () {
    var userInput = localizedLatestPrompt.userInput,
      userADFInput = localizedLatestPrompt.userADFInput,
      presetTitle = localizedLatestPrompt.presetTitle;
    analyticsFlow.addAttributes({
      actionTaken: 'edit-prompt'
    });
    _fireAIAnalyticsEvent({
      payload: {
        action: 'click',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'editPromptButton',
        attributes: {
          experienceType: convertExperienceName(configItem.key.toString()),
          editCount: editCount
        },
        eventType: EVENT_TYPE.UI
      }
    });
    fireDismissEvent();
    sendToAIExperienceMachine({
      type: 'edit prompt',
      userInput: userInput,
      userADFInput: userADFInput,
      presetTitle: presetTitle
    });
  }, [configItem.key, localizedLatestPrompt, analyticsFlow, _fireAIAnalyticsEvent, editCount, fireDismissEvent, sendToAIExperienceMachine]);
  var discardWithoutWarning = useCallback(function () {
    if (shouldDiscardEndExperienceImmediately(promptTrigger, history)) {
      endExperience();
      return;
    }
    var presetTitle = localizedLatestPrompt.presetTitle;
    sendToAIExperienceMachine({
      type: 'edit prompt',
      userInput: '',
      userADFInput: undefined,
      presetTitle: presetTitle
    });
  }, [endExperience, history, localizedLatestPrompt, promptTrigger, sendToAIExperienceMachine]);
  var onBack = useCallback(function () {
    sendToAIExperienceMachine({
      type: 'enable discard',
      context: {
        onceDiscard: discardWithoutWarning
      }
    });
  }, [sendToAIExperienceMachine, discardWithoutWarning]);
  var aiExperienceMetadata = {
    configItemTitle: ((_configItem$agent2 = configItem.agent) === null || _configItem$agent2 === void 0 ? void 0 : _configItem$agent2.name) || convertExperienceName(configItem.key.toString()),
    lastTriggeredFrom: lastTriggeredFrom,
    inputOutputDiffRatio: inputOutputDiffRatio,
    backendModel: backendModel
  };
  var getAIExperience = function getAIExperience(hasUserConsent) {
    return _objectSpread(_objectSpread({}, aiExperienceMetadata), hasUserConsent && {
      userPrompt: localizedLatestPrompt.userInput,
      markdownResponse: markdown
    });
  };
  React.useEffect(function () {
    /**
     * When userInput is empty, we need to clear interrogate editor
     *  as setting empty userInput as defaultValue won't clear editor.
     */
    if (!userInput) {
      var _clearInputRef$curren;
      (_clearInputRef$curren = clearInputRef.current) === null || _clearInputRef$curren === void 0 || _clearInputRef$curren.call(clearInputRef);
    }
  }, [userInput]);
  var onInputChange = React.useCallback(function (inputValue) {
    sendToAIExperienceMachine({
      type: 'update user input',
      input: inputValue
    });
  }, [sendToAIExperienceMachine]);
  var onADFChange = React.useCallback(function (inputValue) {
    sendToAIExperienceMachine({
      type: 'update user input adf',
      adf: inputValue
    });
  }, [sendToAIExperienceMachine]);
  var disableInterrogation = ((_configItem$disableIn = configItem.disableInterrogation) === null || _configItem$disableIn === void 0 ? void 0 : _configItem$disableIn.call(configItem)) || editorPluginAIProvider.disableInterrogation || history.positionFromEnd > 0;
  var onCancelClick = useCallback(function () {
    if (userInput) {
      fireDismissEvent();
      sendToAIExperienceMachine({
        type: 'cancel refinement'
      });
    } else {
      fireDismissEvent();
      discardWithoutWarning();
    }
  }, [userInput, discardWithoutWarning, fireDismissEvent, sendToAIExperienceMachine]);
  var onRetryPromptClick = useCallback(function () {
    _fireAIAnalyticsEvent({
      payload: {
        action: 'click',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'retryPromptButton',
        attributes: {
          experienceType: convertExperienceName(configItem.key.toString())
        },
        eventType: EVENT_TYPE.UI
      }
    });
    fireDismissEvent();
    sendToAIExperienceMachine({
      type: 'retry prompt',
      input: localizedLatestPrompt.userInput,
      adf: localizedLatestPrompt.userADFInput
    });
  }, [configItem.key, _fireAIAnalyticsEvent, fireDismissEvent, localizedLatestPrompt.userADFInput, localizedLatestPrompt.userInput, sendToAIExperienceMachine]);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hasClicked = _React$useState2[0],
    setHasClicked = _React$useState2[1];
  var onActionButtonClick = useCallback(function (_ref3) {
    var runFn = _ref3.runFn,
      analyticsTitle = _ref3.analyticsTitle,
      preserveEditorSelectionOnComplete = _ref3.preserveEditorSelectionOnComplete;
    // We add this condition to ensure we don't run the action multiple times
    // if the user double-clicks quickly (e.g., on slower machines, the re-render
    // might not happen fast enough to disable the button before the second click).
    // Once hasClicked is true, subsequent clicks in the same component lifetime
    // will be ignored—unless we explicitly reset the state after an error, etc.
    if (!hasClicked) {
      try {
        var _editorPluginAIProvid2;
        setHasClicked(true);
        analyticsFlow.addAttributes({
          actionTaken: analyticsTitle
        });
        analyticsFlow.enqueueStep({
          stepName: 'preview'
        });
        // We set this to true to prevent the preview step from being
        // enqueued again on unmount
        // Note -- in future -- we expect the complete step to be deprecated
        // an replaced with a "content highlighted" step
        enqueuedPreviewStep.current = true;
        analyticsFlow.fireQueuedStep('complete');
        var beforeActionRun = performance.now();
        runFn();
        analyticsFlow.enqueueStep({
          stepName: 'complete',
          attributes: {
            actionTaken: analyticsTitle,
            duration: Math.round(performance.now() - beforeActionRun),
            editCount: editCount,
            retryPromptCount: retryPromptCount,
            promptType: promptTrigger,
            refinementCount: refinementCount,
            inputOutputDiffRatio: inputOutputDiffRatio,
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
          }
        });

        /**
         * Please check with Ethan/PM upon removing onExperienceEvent
         * calls, to confirm it is no longer used in any ongoing experiments.
         */
        (_editorPluginAIProvid2 = editorPluginAIProvider.onExperienceEvent) === null || _editorPluginAIProvid2 === void 0 || _editorPluginAIProvid2.EXPERIENCE_COMPLETE();
        endExperience({
          preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete
        });
      } catch (error) {
        setHasClicked(false);
        _fireAIAnalyticsEvent({
          payload: {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'experienceApplication',
            attributes: {
              errorType: 'actionRunError',
              actionTitle: analyticsTitle,
              errorMessage: ErrorUtils.extractErrorMessage(error)
            },
            eventType: EVENT_TYPE.OPERATIONAL
          }
        });
        sendToAIExperienceMachine({
          type: 'error',
          errorInfo: {
            failureReason: FAILURE_REASON.UNKNOWN
          }
        });
      }
    }
  }, [hasClicked, analyticsFlow, editCount, retryPromptCount, promptTrigger, refinementCount, inputOutputDiffRatio, includeKnowledgeFromCurrentPage, editorPluginAIProvider.onExperienceEvent, endExperience, _fireAIAnalyticsEvent, sendToAIExperienceMachine]);
  var mapMarkdownAction = useCallback(function (action) {
    var _action$getDisabledSt, _action$getDisabledSt2;
    // For Rovo actions, we only generate a fragment from the suggested content (without bot pleasantries)
    var contentFragment = action.isRovoAgentAction && rovoAction ? getPMFragmentWithFallback({
      markdown: rovoAction.content || '',
      schema: schema,
      source: 'rovo-action',
      // TODO: EDF-1044 - fix markdownParser failed events
      fireAIAnalyticsEvent: function fireAIAnalyticsEvent() {},
      // Won't be expecting Markdown Plus
      idMap: {}
    }).pmFragment : updatedFragment;
    var _ref4 = (_action$getDisabledSt = (_action$getDisabledSt2 = action.getDisabledState) === null || _action$getDisabledSt2 === void 0 ? void 0 : _action$getDisabledSt2.call(action, {
        markdown: markdown,
        formatMessage: formatMessage
      })) !== null && _action$getDisabledSt !== void 0 ? _action$getDisabledSt : {},
      isDisabled = _ref4.isDisabled,
      tooltip = _ref4.tooltip;
    return {
      label: formatMessage(action.title),
      appearance: action.appearance,
      onClick: function onClick() {
        onActionButtonClick({
          runFn: function runFn() {
            action.run({
              editorView: editorView,
              positions: positions,
              markdown: markdown,
              pmFragment: contentFragment,
              triggeredFor: triggeredFor
            });
            if (configItem.agent && editorPluginAIProvider.onDocChangeByAgent) {
              editorPluginAIProvider.onDocChangeByAgent(configItem.agent);
            }
          },
          analyticsTitle: typeof action.title.defaultMessage === 'string' ? action.title.defaultMessage : ''
        });
      },
      isDisabled: isDisabled || hasClicked,
      tooltip: tooltip
    };
  }, [rovoAction, schema, updatedFragment, markdown, formatMessage, hasClicked, onActionButtonClick, editorView, positions, triggeredFor, configItem.agent, editorPluginAIProvider]);
  var mapAgentAction = useCallback(function (action) {
    return {
      label: formatMessage(action.title),
      appearance: action.appearance,
      icon: action.icon,
      shortcut: action.shortcut,
      onClick: function onClick() {
        onActionButtonClick({
          runFn: function runFn() {
            return action.run({
              channelId: channelId,
              publish: rovoPublish
            });
          },
          analyticsTitle: typeof action.title.defaultMessage === 'string' ? action.title.defaultMessage : '',
          preserveEditorSelectionOnComplete: action.preserveEditorSelectionOnComplete
        });
      }
    };
  }, [channelId, formatMessage, onActionButtonClick, rovoPublish]);
  var createGenericActionPayload = useCreateGenericChatActionPayload();
  var mapGenericChatAction = useCallback(function (_ref5) {
    var title = _ref5.title,
      appearance = _ref5.appearance,
      icon = _ref5.icon,
      shortcut = _ref5.shortcut,
      run = _ref5.run,
      preserveEditorSelectionOnComplete = _ref5.preserveEditorSelectionOnComplete;
    return {
      label: formatMessage(title),
      appearance: appearance,
      icon: icon,
      shortcut: shortcut,
      onClick: function onClick() {
        onActionButtonClick({
          runFn: function runFn() {
            return run(_objectSpread({
              publish: rovoPublish
            }, createGenericActionPayload(history)));
          },
          analyticsTitle: typeof title.defaultMessage === 'string' ? title.defaultMessage : '',
          preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete
        });
      }
    };
  }, [createGenericActionPayload, formatMessage, history, onActionButtonClick, rovoPublish]);

  // We need to use actions from the first config item in history,
  // because during refinement, the user might have selected a different
  // config item, that will have different actions.
  var firstConfigItemActions = getEditorPluginAIConfigItemActions({
    isEmpty: isEmpty,
    configItem: (_history$entries$ = history.entries[0]) === null || _history$entries$ === void 0 ? void 0 : _history$entries$.configItem
  });
  var applications = useMemo(function () {
    var actions = getEditorPluginAIConfigItemActions({
      isEmpty: isEmpty,
      configItem: configItem
    });
    actions = firstConfigItemActions || actions;
    return actions.map(function (action) {
      if (action.type === 'agent') {
        return mapAgentAction(action);
      }
      if (action.type === 'generic-chat') {
        return mapGenericChatAction(action);
      }
      return mapMarkdownAction(action);
    });
  }, [isEmpty, configItem, firstConfigItemActions, mapMarkdownAction, mapAgentAction, mapGenericChatAction]);
  var refineDropdownItems = useMemo(function () {
    var allRefineSuggestions = getAllEditorPluginAIConfigItems({
      configItemWithOptions: editorPluginAIProvider.configItemWithOptions
    }).filter(function (suggestion) {
      return suggestion.showInRefineDropdown;
    });
    var result = [];
    var parentForNesting = {};
    var handleClickAnalytics = function handleClickAnalytics(_ref6) {
      var newConfigItem = _ref6.newConfigItem;
      _fireAIAnalyticsEvent({
        payload: {
          action: 'click',
          actionSubject: 'editorPluginAI',
          actionSubjectId: 'refinementOption',
          attributes: {
            experienceType: convertExperienceName(configItem.key.toString()),
            refinementType: convertExperienceName(newConfigItem.key.toString())
          },
          eventType: EVENT_TYPE.UI
        }
      });
    };
    var handleClick = function handleClick(configItem) {
      return function () {
        handleClickAnalytics({
          newConfigItem: configItem
        });
        sendToAIExperienceMachine({
          type: 'refine',
          configItem: configItem,
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          latestPromptResponse: markdown
        });
      };
    };
    var _iterator = _createForOfIteratorHelper(allRefineSuggestions),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var suggestion = _step.value;
        var nestingConfig = suggestion.nestingConfig;
        if (!nestingConfig) {
          var _suggestion$icon;
          result.push({
            title: suggestion.title,
            icon: /*#__PURE__*/React.createElement(React.Fragment, null, (_suggestion$icon = suggestion.icon) === null || _suggestion$icon === void 0 ? void 0 : _suggestion$icon.call(suggestion, {
              formatMessage: formatMessage
            })),
            onClick: handleClick(suggestion)
          });
        } else {
          var _nestingConfig$parent, _parentForNesting$par, _suggestion$nestingCo, _suggestion$nestingCo2;
          var parentKey = (_nestingConfig$parent = nestingConfig.parentTitle.id) !== null && _nestingConfig$parent !== void 0 ? _nestingConfig$parent : JSON.stringify(nestingConfig.parentTitle);
          if (!parentForNesting[parentKey]) {
            var icon = nestingConfig.icon || suggestion.icon;
            var parent = {
              icon: /*#__PURE__*/React.createElement(React.Fragment, null, " ", icon === null || icon === void 0 ? void 0 : icon({
                formatMessage: formatMessage
              }), " "),
              title: nestingConfig.parentTitle,
              children: []
            };
            result.push(parent);
            parentForNesting[parentKey] = parent;
          }
          (_parentForNesting$par = parentForNesting[parentKey].children) === null || _parentForNesting$par === void 0 || _parentForNesting$par.push({
            title: (_suggestion$nestingCo = (_suggestion$nestingCo2 = suggestion.nestingConfig) === null || _suggestion$nestingCo2 === void 0 ? void 0 : _suggestion$nestingCo2.shortTitle) !== null && _suggestion$nestingCo !== void 0 ? _suggestion$nestingCo : suggestion.title,
            onClick: handleClick(suggestion)
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return result;
  }, [configItem.key, editorPluginAIProvider.configItemWithOptions, _fireAIAnalyticsEvent, formatMessage, markdown, sendToAIExperienceMachine]);
  var refinementButtonClick = useCallback(function () {
    _fireAIAnalyticsEvent({
      payload: {
        action: 'click',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'refinementButton',
        attributes: {
          experienceType: convertExperienceName(configItem.key.toString())
        },
        eventType: EVENT_TYPE.UI
      }
    });
  }, [configItem.key, _fireAIAnalyticsEvent]);
  return /*#__PURE__*/React.createElement(PreviewScreen, {
    key: configItem.key,
    parentPresetPromptLabel: parentPresetPromptLabel,
    childShortTitle: childShortTitle,
    latestPrompt: localizedLatestPrompt,
    diffPreview: diffPreview,
    canShowVisualDiffPreview: isVisualDiffPreviewEnabled,
    preview: preview,
    disableActions: !!responseTooSimilar,
    inputValue: userInput,
    inputADFValue: userADFInput,
    isInputActive: isInputActive,
    onCancel: onCancelClick,
    onInputChange: onInputChange,
    onADFChange: onADFChange,
    onInputFocus: function onInputFocus() {
      sendToAIExperienceMachine({
        type: 'start refinement'
      });
    },
    onInputBlur: function onInputBlur() {
      if (!userInput) {
        sendToAIExperienceMachine({
          type: 'cancel refinement'
        });
      }
    },
    onSubmit: function onSubmit() {
      /**
       * Do we really need to pass userInput and userADFInput
       *  on firing interrogate event.
       * We should have latest userInput and userADFInput
       *  set by onInputChange and onADFChange.
       */
      sendToAIExperienceMachine({
        type: 'interrogate',
        userInput: userInput,
        userADFInput: userADFInput,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        latestPromptResponse: markdown
      });
    },
    onCopy: function onCopy() {
      _fireAIAnalyticsEvent({
        payload: {
          action: 'click',
          actionSubject: 'editorPluginAI',
          actionSubjectId: 'copyButton',
          attributes: {
            experienceType: convertExperienceName(configItem.key.toString()),
            editCount: editCount
          },
          eventType: EVENT_TYPE.UI
        }
      });
      analyticsFlow.addAttributes({
        contentCopied: true
      });
      copyPMFragmentToClipboard({
        editorView: editorView,
        pmFragment: pmFragment
      });
    },
    onRetry: !configItem.agent ? onRetryPromptClick : undefined,
    onGoodResponseButtonClick: function onGoodResponseButtonClick() {
      var feedbackMetadata = {
        sentiment: 'good',
        getAIExperience: getAIExperience,
        editorAttributes: {
          appearance: appearance,
          product: product
        }
      };

      // Now deprecated - migrate to handleFeedbackSubmission
      editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
      handleFiringFeedbackEvent(feedbackMetadata);
    },
    onBadResponseButtonClick: function onBadResponseButtonClick() {
      var feedbackMetadata = {
        sentiment: 'bad',
        getAIExperience: getAIExperience,
        editorAttributes: {
          appearance: appearance,
          product: product
        }
      };

      // Now deprecated - migrate to handleFeedbackSubmission
      editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
      handleFiringFeedbackEvent(feedbackMetadata);
    },
    onEditPromptClick: onEditPromptClick,
    onBack: onBack,
    applications: applications,
    secondaryActions: ((_configItem$secondary = configItem.secondaryActions) !== null && _configItem$secondary !== void 0 ? _configItem$secondary : []).map(function (action) {
      return mapAgentAction(action);
    }),
    PromptEditor: editorPluginAIProvider.PromptEditor,
    clearInputRef: clearInputRef,
    disclaimer: disclaimer,
    providerFactory: providerFactory,
    schema: schema,
    disableInterrogation: disableInterrogation,
    agent: configItem.agent,
    onRefinementClick: refinementButtonClick,
    refineDropdownItems: refineDropdownItems
  });
}